// 공지 목록 줄(시안 .ntc). 삭제는 두 번 눌러 확정(3초 안에 「정말 삭제」).
import { useEffect, useRef, useState } from "react";
import { kstFull } from "../../inquiry/view";
import { plain } from "./noticeView";

const STATUS_TAG = {
    active: <span className="tag tag-live">게시중</span>,
    scheduled: <span className="tag tag-res">예약</span>,
    expired: <span className="tag tag-exp">만료</span>,
};

function DeleteButton({ onConfirm }) {
    const [armed, setArmed] = useState(false);
    const timer = useRef(null);
    useEffect(() => () => clearTimeout(timer.current), []);
    const click = () => {
        if (armed) { clearTimeout(timer.current); setArmed(false); onConfirm(); return; }
        setArmed(true);
        timer.current = setTimeout(() => setArmed(false), 3000);
    };
    return (
        <button className="btn btn-sm btn-danger" aria-label="삭제" title="두 번 눌러 삭제" onClick={click}>
            {armed ? "정말 삭제" : <i className="fa-regular fa-trash-can"></i>}
        </button>
    );
}

function Row({ n, onEdit, onDelete }) {
    const imp = n.is_important;
    return (
        <div className="ntc" data-id={n.id}>
            <span className="ic" style={{ background: imp ? "var(--red-l)" : "#eef3ff", color: imp ? "var(--red)" : "var(--pri)" }}>
                <i className={`fa-solid ${imp ? "fa-triangle-exclamation" : "fa-bullhorn"}`}></i></span>
            <div className="bd">
                <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                    <b>{n.title}</b>{STATUS_TAG[n.status]}
                    <span className={`tag ${imp ? "tag-imp" : "tag-gen"}`}>{imp ? "중요 · 키오스크 팝업" : "일반 · 공지 메뉴"}</span>
                    {n.title_zh ? <span className="tag tag-zh">中文</span> : null}
                </div>
                <p>{plain(n.content)}</p>
                <div className="meta">
                    <span><i className="fa-regular fa-calendar"></i> {n.start_at ? kstFull(n.start_at) : "즉시"} ~ {n.end_at ? kstFull(n.end_at) : "무기한"}</span>
                    <span><i className="fa-regular fa-user"></i> {n.author_name || "작성자 없음"} · {kstFull(n.created_at)}</span>
                    <span><i className="fa-regular fa-eye"></i> 조회 {Number(n.view_count || 0).toLocaleString("ko-KR")}</span>
                    {n.push_requested
                        ? <span title={n.push_sent_at ? `${kstFull(n.push_sent_at)} 발송` : "발송 대기"}><i className="fa-regular fa-bell"></i> 앱 푸시{n.push_sent_at ? " · 발송됨" : ""}</span>
                        : null}
                </div>
            </div>
            <div className="act">
                <button className="btn btn-sm" onClick={() => onEdit(n)}><i className="fa-regular fa-pen-to-square"></i>수정</button>
                <DeleteButton onConfirm={() => onDelete(n)} />
            </div>
        </div>
    );
}

export default function NoticeList({ rows, onEdit, onDelete }) {
    return <div id="ntList">{rows.map((n) => <Row key={n.id} n={n} onEdit={onEdit} onDelete={onDelete} />)}</div>;
}
